import { Table, TableBody, TableRow, TableCell } from "@mui/material"
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { BalllotReviewProps } from "../types";
import { REFEREDUM_VALUE } from "./types";

export const YesNoReview = ({ response }: BalllotReviewProps<REFEREDUM_VALUE>) => {
    return (
        <Table size="small">
            <TableBody>
                <TableRow>
                    <TableCell align="center" width={20}>
                        {response === "YES" ? <CheckIcon /> : <CloseIcon />}
                    </TableCell>
                    <TableCell>
                        {response as string}
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    )
}